import { useEventListener } from './EventListener';

/**
 * @deprecatedSince 9
 * @deprecated Never officially documented/supported
 */

/**
 * @deprecatedSince 9
 * @deprecated Never officially documented/supported
 */
export function useScroll(_ref) {
  var onScroll = _ref.onScroll,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? window : _ref$scope;
  return useEventListener({
    event: 'scroll',
    handler: onScroll,
    scope: scope
  });
}
//# sourceMappingURL=Scroll.js.map